import { Component, inject, OnInit } from '@angular/core';
import { BrandsListConfigService } from '../../../services/brands/brands-list-config.service';
@Component({
    selector: 'lib-brands-manager',
    templateUrl: './brands-manager.component.html',
    styleUrls: ['./brands-manager.component.css'],
    standalone: false
})
export class BrandsManagerComponent{
  public brandsListConfigService = inject(BrandsListConfigService);

  
}
